import { useEffect } from 'react';
import Portal from '../atoms/Portal';
import { X } from 'lucide-react';

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md', // 'md' | 'lg' | 'xl'
}) {
  useEffect(() => {
    if (!isOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <Portal>
      <div className="modal-backdrop" onClick={onClose}>
        <div
          className={`modal-content modal-content--${size}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content__header">
            <h3 className="modal-content__title">{title}</h3>
            <button className="modal-content__close" onClick={onClose}>
              <X size={18} />
            </button>
          </div>
          <div className="modal-content__body">{children}</div>
          {footer && <div className="modal-content__footer">{footer}</div>}
        </div>
      </div>
    </Portal>
  );
}
